import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { quyCheApi } from "../../../api/category/quyCheApi";
import { IBaseResponse } from "../../../model/response/IBaseResponse";
import { rootActions } from "../../actions/rootActions";
import { IQuyChe } from "../../../model/response/category/IQuyChe";
import { eQuyCheActionIds, IQuyCheActionTypes } from "../../action-types/category/IQuyCheActions";

const mainAction = rootActions.category.quyChe;
export function* quyCheSaga(): any {
    yield takeLatest(eQuyCheActionIds.LOAD_START, loadWoker);
    yield takeEvery(eQuyCheActionIds.SAVE_START, saveWorker);
    yield takeEvery(eQuyCheActionIds.DELETE_START, deleteWorker);
}
function* loadWoker(): any {
    const res: IBaseResponse = yield call(quyCheApi.SelectAll);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải Quy chế"));
    }
}
function* saveWorker(action: IQuyCheActionTypes): any {
    let res: IBaseResponse;
    const payload = action.payload as IQuyChe;
    if (payload.id > 0){
        res = yield call(quyCheApi.Update, payload.id, payload);
    } else {
        res = yield call(quyCheApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu Quy chế"));
    }
}

function* deleteWorker(action: IQuyCheActionTypes): any {
    const id = action.payload as number;
    const res: IBaseResponse = yield call(quyCheApi.Delete, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa Quy chế"));
    }
}